module.exports = __webpack_public_path__ + "img/data.d9cd66cb.jpg";